import React, { useEffect, useState } from "react";
import "./PurchaseOrderDeliveryDetailPopupTab.scss";
import ApiService from "../../services/apiService";
import URLS from "../../urls/Urls";
import { PURCHASE_ORDER_STATUSES } from "../../pages/PurchaseOrderStatus/ClientPurchaseOrder.data";
import { formatDate } from "../../utils/Helper";

interface IDeliverySchedule {
  actual_delivery_date: null | string;
  delivered_quantity: number;
  expected_delivery_date: string;
  id: number;
  pod: null | string;
  procurement_request_product_id: number;
  track_link: string | null;
  dispatch_date: string | null;
  invoice: string | null;
  invoice_id: string | null;
}

interface PODeliveryDetailPopupProps {
  procurementReuqestProductId: number;
  handleClose: () => void;
  unit: string;
  skuName: string;
}

const PurchaseOrderDeliveryDetailPopupTab: React.FC<
  PODeliveryDetailPopupProps
> = ({ procurementReuqestProductId, handleClose, unit, skuName }) => {
  const [deliverySchedules, setDeliverySchedules] = useState<
    IDeliverySchedule[]
  >([]);

  const [currentStage, setCurrentStage] = useState("");
  const [allCompletedStages, setAllCompletedStages] = useState<
    { status: string; created_at: string; id: number }[]
  >([]);

  useEffect(() => {
    getDeliverySchedules();
  }, []);

  const getDeliverySchedules = async () => {
    try {
      const { data } = await ApiService().client.get(
        URLS.PURCHASE_ORDER.CLIENT_PO_DELIVERY_SCHEDULE(
          procurementReuqestProductId
        )
      );
      setDeliverySchedules(data.data);
      if (data.statuses.length > 0) {
        setCurrentStage(data.statuses[0].status || "");
        setAllCompletedStages(data.statuses);
      }
    } catch (e) {
      console.error("Error Fetching Delivery Schedules:", e);
    }
  };

  return (
    <div className="pod-delivery-detail-popup-container-tab p-8 flex-column gap-8 full-width  border-box">
      {deliverySchedules.length > 0 && (
        <div className="p-8 stages-map flex-column gap-8">
          <div className="flex-row align-items-center justify-content-space-between ">
            <p
              style={{ color: "black" }}
              className="xetgo-font-subHeading bold"
            >
              {skuName}
            </p>
            <img
              onClick={handleClose}
              className="cursor-pointer"
              height={24}
              width={24}
              src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240624162818-close+2.svg"
              alt="close-icon"
            />
          </div>
          <p className="xetgo-font-tag bolder">Stages</p>
          <div
            onClick={(e) => e.stopPropagation()}
            className="all-steps-main-container flex-column p-8"
          >
            {(() => {
              // Find the current step index, default to 0 if no match found
              let currentStepIndex = PURCHASE_ORDER_STATUSES.findIndex(
                (step) => step.value === currentStage
              );
              if (currentStepIndex === -1) currentStepIndex = 0;

              return PURCHASE_ORDER_STATUSES.map((step, stepIndex) => {
                const isCompleted = stepIndex <= currentStepIndex;
                const stageRecord = allCompletedStages.find(
                  (s) => s.status === step.value
                );
                const completedStageDate = stageRecord?.created_at;
                return (
                  <div
                    key={stepIndex}
                    className="step-container xetgo-font-tag flex-column"
                    style={{
                      cursor: "default",
                    }}
                  >
                    <div className="flex-row align-items-center justify-content-space-between full-width">
                      <div className="flex-row align-items-center gap-10 flex-1 ">
                        <img
                          className="status-icon"
                          src={
                            isCompleted ? step.active_icon : step.inactive_icon
                          }
                          alt="status-icon"
                        />
                        <div className="flex-row gap-4">
                          <p
                            className={`bolder ${
                              isCompleted ? "active-step" : ""
                            }`}
                          >
                            {step.name}
                          </p>
                        </div>
                      </div>
                      <p>
                        {completedStageDate &&
                        !isNaN(new Date(completedStageDate).getTime())
                          ? formatDate(completedStageDate)
                          : "-"}
                      </p>
                    </div>

                    {stepIndex !== PURCHASE_ORDER_STATUSES.length - 1 && (
                      <p
                        className={`dots-line flex-row align-items-center flex-1 ${
                          isCompleted ? "active-step" : ""
                        }`}
                      >
                        . . .
                      </p>
                    )}
                  </div>
                );
              });
            })()}
          </div>
        </div>
      )}

      <div className="all-invoices-container flex-column gap-8">
        {deliverySchedules.length > 0 ? (
          deliverySchedules.map((delivery, index) => (
            <div
              className={`invoice-main-container flex-column gap-16 py-10 px-12 ${
                index % 2 !== 0 && "even-invoice-main-container "
              }`}
              key={index}
            >
              <div className="flex-row gap-12 align-items-center">
                <p className="xetgo-font-button bold">Invoice ID:</p>
                <p
                  style={{ color: "#333333" }}
                  className="xetgo-font-button bold"
                >
                  {delivery.invoice_id || "-"}
                </p>
              </div>
              <div className="flex-row justify-content-space-between">
                <div className="flex-row gap-12 align-items-center">
                  <p className="xetgo-font-button bold">Qty:</p>
                  <p
                    style={{ color: "#333333" }}
                    className="xetgo-font-button bold"
                  >
                    {delivery.delivered_quantity || "-"} {unit}
                  </p>
                </div>
                <div className="flex-row gap-12 align-items-center">
                  <p className="xetgo-font-button bold"> Exp:</p>
                  <p
                    style={{ color: "#333333" }}
                    className="xetgo-font-button bold"
                  >
                    {delivery.expected_delivery_date || "-"}
                  </p>
                </div>
              </div>
              <div className="flex-row gap-12 align-items-center">
                <p className="xetgo-font-button bold">Track:</p>
                <p
                  style={{
                    color: "#333333",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                  className="xetgo-font-button bold"
                >
                  {delivery.track_link || "-"}
                </p>
              </div>
              <div className="flex-row justify-content-space-between">
                <div className="flex-row gap-12 align-items-center">
                  <p className="xetgo-font-button bold">Disp:</p>
                  <p
                    style={{ color: "#333333" }}
                    className="xetgo-font-button bold"
                  >
                    {delivery.dispatch_date || "-"}
                  </p>
                </div>
                <div className="flex-row gap-12 align-items-center">
                  <p className="xetgo-font-button bold"> Delivered:</p>
                  <p
                    style={{ color: "#333333" }}
                    className="xetgo-font-button bold"
                  >
                    {delivery.actual_delivery_date || "-"}
                  </p>
                </div>
              </div>
              <div className="flex-row gap-12">
                {delivery.invoice && (
                  <a
                    style={{ color: "#5151ec" }}
                    target="_blank"
                    href={delivery.invoice}
                    rel="noopener noreferrer"
                    key={`pod-${index}`}
                    className="invoice-pod-btn px-12 py-7 flex-row align-items-center justify-content-center gap-8 cursor-pointer"
                  >
                    <p className="xetgo-font-button bold">Invoice</p>

                    <img
                      height={18}
                      width={18}
                      src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240904094334-download_purple.svg"
                      alt="download-icon"
                    />
                  </a>
                )}
                {delivery.pod && (
                  <a
                    style={{ color: "#5151ec" }}
                    target="_blank"
                    href={delivery.pod}
                    rel="noopener noreferrer"
                    key={`pod-${index}-${delivery.id}`}
                    className="invoice-pod-btn px-12 py-7 flex-row align-items-center justify-content-center gap-8 cursor-pointer"
                  >
                    <p className="xetgo-font-button bold">POD</p>
                    <img
                      src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240510114359-arrow-right+%282%29.svg"
                      alt="uploaded"
                      width={16}
                      height={16}
                    />
                  </a>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="empty-state-pod-detail-popup flex-column gap-12 align-items-center justify-content-center xetgo-font-tag">
            <img
              height={21}
              width={21}
              src="https://d2k6zobmg5lufr.cloudfront.net/assets%2F20240808061403-Document+add.svg"
              alt="empty-icon"
            />
            <p className="bold xetgo-font-body">No added data to show</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default PurchaseOrderDeliveryDetailPopupTab;
